export default __webpack_public_path__ + "static/media/US_Hero2_1.f76d8dc9.png";